import React, { Component } from 'react';

// Import the CSS
import '../../scss/components/_select.scss';

export default class Select extends Component {
	render () {
		return (
			<select { ...this.props }>
				{ this.props.children }
			</select>
		);
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/components/Select.js